export default __webpack_public_path__ + "locales/ro/JavascriptSdk.json?hash=d6e78b8adc7f2225248b587f430bcd69";